// extracted by mini-css-extract-plugin
module.exports = {"component":"MultiSelectButton-component--KONqS"};